<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template v-for="(item, key) in textList" :key="key">
      <div>{{ key + 1 }}、{{ item.value }}</div>
    </template>
  </a-modal>
</template>
   
<script>
import { defineComponent, reactive, ref } from "vue";

export default defineComponent({
  props: {
    text: String,
  },
  setup(props, context) {
    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const textList = ref([]);

    const show = (text, title, isRever) => {
      modalConfig.visible = true;
      modalConfig.title = title;
      textList.value.length = 0;
      if (text && text.indexOf("[") !== -1) {
        const textArray = JSON.parse(text);
        textArray.forEach((text) => {
          if (isRever) {
            textList.value.unshift(text);
          } else {
            textList.value.push(text);
          }
        });
      }
    };

    const handleCancel = () => {
      modalConfig.visible = false;
      textList.value.length = 0;
    };

    const handleOk = () => {
      handleCancel();
    };

    return {
      textList,
      modalConfig,
      handleOk,
      show,
      handleCancel,
    };
  },
});
</script>
   
<style lang="less" scoped>
</style>